/**
 * MetaPixelPageView — SPA route-change hook for the Meta Pixel.
 *
 * Fires `fbq('track', 'PageView')` on initial mount and on every
 * subsequent route change, EXCEPT when the route is admin-scoped
 * (`/admin/*`) OR the caller is inside an impersonation session
 * (`user.is_impersonating === true`).
 *
 * Renders nothing — pure side-effect component. Mounted once near
 * the top of the route tree (see `App.js`) alongside
 * `<RouteViewSync />`. When the pixel loader in `public/index.html`
 * did not initialize (empty `REACT_APP_META_PIXEL_ID`), every call
 * short-circuits — no `fbq` global, no network activity.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { trackPageView } from "@/lib/metaPixel";

export default function MetaPixelPageView() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isImpersonating = !!user?.is_impersonating;

  useEffect(() => {
    trackPageView(pathname, { isImpersonating });
  }, [pathname, isImpersonating]);

  return null;
}
